function Layout({ children }) {
  return (
    <div className="amellis__main">
      <div className="amellis__container">
        <div className="amellis__wrapper">{children}</div>
      </div>
    </div>
  );
}

export default Layout;
